/* eslint-disable no-param-reassign */
import CONSTANTS from '@picsio/db/src/constants';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { added } from '../keywords/actions';
import { add } from '../keywordsList/actions';
import { findListingEntity } from './helpers/entityReadHelpers';
import { upsertListing } from './helpers/entityAdapter';

export const addListingKeywords = createAsyncThunk(
  'products/addListingKeywords',
  async ({
    productId, masterProductId, channelId, keywordName,
  }, {
    extra: {
      sdk, Logger, utils, showErrorDialog,
    },
    dispatch,
  }) => {
    try {
      const { data: keywords } = await sdk.products.addKeywords([productId], keywordName);

      keywords.forEach((keyword) => {
        const clonedKeyword = { ...keyword };

        if (clonedKeyword.isNew) {
          clonedKeyword.isFavorite = false;
          clonedKeyword.count = 0;
          dispatch(added([clonedKeyword]));
        } else {
          dispatch(add([{
            ...clonedKeyword,
            name: clonedKeyword.name || clonedKeyword.path.split(CONSTANTS.NEW_PATH_DELIMITER).pop(),
          }]));
        }
      });

      return keywords;
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not add keyword to product';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error add keyword to product'), { error }, [
        'AddKeywordToProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(addListingKeywords.fulfilled, (state, { payload: keywords, meta }) => {
    const { masterProductId, channelId } = meta.arg;
    const existingListing = findListingEntity(state, { masterProductId, channelId });
    if (!existingListing) return;

    upsertListing(state, {
      ...existingListing,
      masterProductId,
      keywords: [
        ...(existingListing.keywords || []).filter((k) => !keywords.find(({ _id }) => _id === k._id)),
        ...keywords,
      ],
    });
  });
};
